export default "__VITE_ASSET__fFJ_Q63c__"